export default __webpack_public_path__ + "static/media/background1.7cf8915c.svg";